/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Select from 'react-select';
import { customStyle } from 'helper';
import SelectDateFilter from 'modules/common/components/SelectDateFilter';
import Loading from 'modules/common/components/Loading';
import moment from 'moment';
import PropTypes from 'prop-types';
import withDashboard from '../../../common/hoc/withDashboard';

import * as actions from '../action';
import * as c from '../constant';
import CedulaChartComponent from '../components/CedulaChartComponent';

const colors = ['#5272AA', '#8EEED7'];

const renderLegends = (dt) =>
  dt.map((x) => {
    return (
      <div key={x.name} className="legend-item">
        <div
          style={{
            background: `${x.color}`,
            width: 20,
            height: 20,
            marginRight: 20,
          }}
        />
        <div className="legend-text">{x.name}</div>
      </div>
    );
  });

const filter = {
  transaction_type: 'ALL',
};

function CedulaDashboardContainer({
  graphStats,
  getGraphStats,
}) {
  const [filterData, setFilterData] = useState(filter);
  const [isLoading, setIsLoading] = useState(true);

  const handleOnSubmit = (data) => {
    const args = {
      ...data,
      permit_type: 'Community Tax Certificate CTC / CEDULA',
    }
    getGraphStats(args);
  };


  // const handleOnSubmit = ({ type, from, to }) => {
  //   // eslint-disable-next-line no-console
  //   getGraphStats({
  //     period: type,
  //     date_from: from,
  //     date_to: to,
  //     permit_type: 'Community Tax Certificate CTC / CEDULA',
  //   });
  // };

  const handleChangeSelect = (e) => {
    setFilterData({
      ...filterData,
      transaction_type: e ? e.value : '',
    });
  };

  const formatKey = [
    {
      key: 'INDIVIDUAL',
      color: `${colors[0]}`,
    },
    {
      key: 'CORPORATION',
      color: `${colors[1]}`,
    },
  ];

  useEffect(() => {
    getGraphStats();
    setIsLoading(false);
    return () => {
      setIsLoading(false);
    };
  }, []);

  return (
    <div className="dashboard-card">
      <div className="row mb-3">
        <div className="col-12">
          <div className="main-text">Statistics</div>
        </div>
        <div className="stat-filters">
          <SelectDateFilter onSubmit={handleOnSubmit} />
        </div>
        {isLoading && <Loading />}
        <div className="col-12">
          <CedulaChartComponent
            chartData={graphStats}
          />
        </div>
        <div className="legends-wrapper area px-3 w-100">
          <div
            className="render-chart-legends"
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'row',
              flexWrap: 'wrap',
            }}
          >
            {renderLegends(c.CEDULA)}
          </div>
        </div>
      </div>
    </div>
  );
}

CedulaDashboardContainer.propTypes = {
  graphStats: PropTypes.instanceOf(Array).isRequired,
  getGraphStats: PropTypes.instanceOf(Function).isRequired,
};

// const formatGraphData = (data) => {
//   const labels = [];
//   const values = [];

//   data.forEach((item, i) => {
//     const entries = Object.entries(item).filter(
//       (a) => ['name', 'included', 'RPT', 'BPLS'].indexOf(a[0]) < 0
//     );

//     if (i === 0) {
//       entries.forEach((entry, x) => {
//         labels[x] = {
//           key: entry[0],
//           color: colors[x],
//         };
//       });
//     }

//     values[i] = rename(
//       rename(
//         rename(item, 'OHP', 'Occupational / Health Permits'),
//         'CDL',
//         'Community Tax CertificateCTC / CEDULA'
//       ),
//       'PSA',
//       'Civil Registry Office'
//     );
//   });

//   return {
//     labels,
//     values,
//   };
// };

const mapStateToProps = ({ api }) => ({
  graphStats: _.get(api, `${c.GET_GRAPH_STATS}.list`) || [],
  transactionList: [
    {
      INDIVIDUAL: 812,
      CORPORATION: 340,
      name: 'JAN',
    },
    {
      INDIVIDUAL: 512,
      CORPORATION: 121,
      name: 'FEB',
    },
  ],
});

const enhance = _.flowRight([
  withDashboard,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(CedulaDashboardContainer);
